import * as React from 'react'

import MagnifierConfigurator from '../magnifier/configurator'
import Overlay from '../overlay'

import { IItem } from '../../../typings/searchResults'

import * as styles from './index.module.css'

const ItemPreviewer = ({
  item,
  annotation,
  videoMuted,
  muteVideo
}: {
  item: IItem
  annotation?: string
  videoMuted: boolean
  muteVideo: () => void
}) => {
  const overlayContent = (
    <div className={styles.magnifier}>
      <MagnifierConfigurator
        item={item}
        videoMuted={videoMuted}
        muteVideo={muteVideo}
      />
    </div>
  )

  return (
    <div>
      <Overlay position="side" content={overlayContent}>
        <a href={item.url}>
          <img
            alt={item.name}
            className={styles.img}
            src={item.ui.smallPreviewUrl}
            title={item.name}
          />
        </a>
      </Overlay>
      {annotation && <small className={styles.annotation}>{annotation}</small>}
    </div>
  )
}

export default ItemPreviewer



// WEBPACK FOOTER //
// ./client/components/itemPreviewer/index.tsx